import { css } from "@emotion/css";
import React from "react";

import { useMediaQuery } from "../../../utils";
export interface InputWrapperProps {
  span?: number | "auto" | number[];
  children?: React.ReactNode;
  testID?: string;
}

export function InputWrapper({
  span,
  children,
  testID = "input-wrapper",
}: InputWrapperProps) {
  const { mediaQuery } = useMediaQuery();

  return (
    <div
      className={css(
        styles.section,
        Array.isArray(span)
          ? mediaQuery({
              gridColumnEnd: span.map((col) => `span ${col}`),
            })
          : {
              gridColumnStart: span === "auto" ? 1 : undefined,
              gridColumnEnd: span === "auto" ? 7 : `span ${span}`,
            }
      )}
      data-testid={testID}
    >
      {children}
    </div>
  );
}

const styles = {
  section: css({
    width: "100%",
    display: "flex",
    flexDirection: "column",
  }),
};
